import * as React from 'react'

import { useForm, UseFormReturn } from 'react-hook-form'

import { FieldConfig, FieldType } from './types'

const defaultByType: Record<FieldType, unknown> = {
  [FieldType.TEXT]: '',
  [FieldType.TEXTAREA]: '',
  [FieldType.NUMBER]: null,
  [FieldType.SELECT]: null,
  [FieldType.HIERARCHY]: null,
  [FieldType.DATETIME]: null,
  [FieldType.CHECKBOX]: false,
  [FieldType.USER]: '',
  [FieldType.COMPANY]: '',
  [FieldType.FILE]: [],
  [FieldType.LOCATION]: '',
  [FieldType.COLOR]: null,
  [FieldType.ICON]: null,
  [FieldType.PARENT]: null,
}

function emptyValueFor(field: FieldConfig): unknown {
  if (field.type === FieldType.SELECT && field.multiSelect) {
    return []
  }
  return defaultByType[field.type] ?? null
}

export function useDynamicForm(
  fields: FieldConfig[],
): UseFormReturn<Record<string, unknown>> {
  const values = React.useMemo(
    () =>
      Object.fromEntries(
        fields.map(f => [f.name, f.defaultValue ?? emptyValueFor(f)]),
      ),
    [fields],
  )

  return useForm<Record<string, unknown>>({
    values,
    resetOptions: { keepDirtyValues: true },
  })
}
